// extracted by mini-css-extract-plugin
export default {"description":"index_description__FOEAf"};